/* eslint-disable camelcase */
import { OptionType } from '@evinced-private/ui-common';

import { SEVERITY_FILTER_MAP } from 'src/apps/mobile-common/types/CommonTypes';
import {
	Mfa_Session_RunsOrFilter,
	Msdk_Test_RunsOrFilter
} from 'src/common/types/graphql.generated';

type OrFilter = Mfa_Session_RunsOrFilter | Msdk_Test_RunsOrFilter;

/**
 * Builds severity filter variables for Mobile SDK or MFA queries.
 * Converts severity options to the appropriate GraphQL OR filter format.
 *
 * @param severityOptions - Array of selected severity options
 * @returns Object with severityOrFilter array if options exist, empty object otherwise
 */
export const buildSeverityFilterVariables = <T>(severityOptions?: OptionType[]): Partial<T> => {
	if (!severityOptions || severityOptions.length === 0) {
		return {};
	}

	const orFilters: OrFilter[] = severityOptions
		.map((option) => {
			const filterKey = SEVERITY_FILTER_MAP[option.value];
			if (!filterKey) {
				return null;
			}
			return { [filterKey]: { value: [0] } };
		})
		.filter((filter): filter is OrFilter => filter !== null);

	return orFilters.length > 0 ? ({ severityOrFilter: orFilters } as unknown as Partial<T>) : {};
};
